<div class="coverages-outer-container" [formGroup]="form">
  @if (showPremium) {
    <div class="premium-section bolt-justify-content-center">
      <h2 class="premium-monthly" id="ucdc-premium-monthly">
        {{ priceSummaryDisplayProduct.installmentPrice }}
        <span class="per-month"><strong>{{
          priceSummaryDisplayProduct.installmentFrequency
        }}</strong></span>
      </h2>
    </div>
    <div class="bolt-row bolt-justify-content-center">
      <h3 class="premium-total" id="ucdc-premium-total">
        {{ priceSummaryDisplayProduct.totalPrice }}
        {{ priceSummaryDisplayProduct.termLength }}
      </h3>
    </div>
    <hr />
  }

  <div class="bolt-row effective-container">
    <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
      @if (!showDatePicker) {
        <div
          class="update-effectiveDate-container"
          (click)="showDatePicker = true"
          >
          <a id="ucdc-Effective-date-{{ product.type }}"
            >Effective date {{ form.value.effectiveDate }}</a
            >
            <bolt-icon
              name="pencil"
              [attr.id]="'ucdc-pencil-' + product.type"
              color="mediumBlue"
              [attr.size]="maxSizeMini ? 'sm' : 'md'"
              class="icon-top-padding mt-05"
            ></bolt-icon>
          </div>
        }
        @if (showDatePicker) {
          <nwx-datepicker-input
            controlId="effectiveDate"
            id="ucdc-effective-date"
            label="Effective date"
            controlName="effectiveDate"
            placeholder="MM/DD/YYYY"
            [minDate]="policyDateOptions?.minDate || null"
            [maxDate]="policyDateOptions?.maxDate || null"
            [disabled]="(updateInProgress$ | async) || false"
            [relevantProduct]="product.type"
            [quoteCreateDate]="product.quoteCreateDate"
            [bumpHeaderMargin]="true"
          ></nwx-datepicker-input>
        }
      </div>
      <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
        <div
          class="remove-policy-container"
          (click)="promptToRemovePolicy($event)"
          id="ucdc-remove-policy"
          >
          <a href="#">Save submission for later</a>
          <bolt-icon
            name="folder"
            [attr.id]="'ucdc-folder'"
            color="mediumBlue"
            [attr.size]="maxSizeMini ? 'sm' : 'md'"
            class="icon-top-padding"
          ></bolt-icon>
        </div>
        <div
          class="remove-policy-container"
          (click)="promptToWithdrawPolicy($event)"
          id="ucdc-withdraw-policy"
          >
          <a href="#">Delete submission</a>
          <bolt-icon
            name="trash"
            [attr.id]="'ucdc-trash'"
            color="mediumBlue"
            [attr.size]="maxSizeMini ? 'sm' : 'md'"
            class="icon-top-padding"
          ></bolt-icon>
        </div>
      </div>
    </div>
    <hr />

    @if (showPremium ) {
      <div class="details-container">
        <div class="info-row heading">
          <div class="bolt-row bolt-justify-content-between">
            <div class="bolt-col-xs-6">
              <strong>Limits overview</strong>
            </div>
          </div>
        </div>
        @for (limit of overviewLimits; track limit.name) {
          <div
            class="bolt-row bolt-justify-content-between info-row"
            >
            <div class="bolt-col-xs-xs-6">{{ limit.name }}</div>
            <div class="bolt-col-xs-xs-6">
              {{ limit.value }}
            </div>
          </div>
        }
      </div>
      <div class="coverages-footer">
        <!--<div class="bolt-row">
        <div class="bolt-col-xs">
          <bolt-button
            type="solid"
            size="sm"
            [attr.id]="'ucdc-view-edit-all-coverages'"
            (click)="editCoverages()"
            >View/edit all coverages</bolt-button
            >
          </div>
        </div>-->
      </div>
    } @else {
      <div class="coverages-footer pb-20" id="ucdc-premiumSubstitute">
        <nwx-notification-bubble type="info">
          <p style="font-size: large; font-weight: 500;">Review your rating tasks</p>
          <p>The rate isn’t available, because there may be unfinished tasks or errors. If you see any errors, request UW approval.</p>
          <div class="d-flex flex-column bolt-justify-content-between">
            <bolt-button color="mediumBlue"
              type="outline"
              class="button-float"
              size="md"
              (click)="scrollToTasks()"
              >Review rating tasks</bolt-button
              >
            </div>
          </nwx-notification-bubble>
        </div>
        <hr />
        <div class="details-container-last"></div>
      }
      <div class="button-container">
        <div class="bolt-row">
          <div class="bolt-col-xs">
            <bolt-button
              type="solid"
              size="sm"
              [attr.id]="'acdc-view-edit-coverage'"
              (click)="editCoverages()"
              >View/edit all coverages</bolt-button
              >
            </div>
          </div>
        </div>
      </div>

